import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { useState } from 'react';
import { TextField } from '@mui/material';
import { isEmailInvalid } from '../../helpers/general.helpers';

export interface InviteGuardianDialogProps {
  isOpen: boolean;
  handleClose: any;
  handleSubmit: any;
  isLoading: boolean;
}

export default function InviteGuardianDialog(props: InviteGuardianDialogProps) {
  const [guardianEmail, setGuardianEmail] = useState<string>('');
  const [guardianEmailError, setGuardianEmailError] = useState<string>('');

  const closeModal = () => {
    setGuardianEmail('');
    setGuardianEmailError('');
    props.handleClose();
  };

  const submit = () => {
    setGuardianEmailError('');
    if (isEmailInvalid(guardianEmail)) {
      setGuardianEmailError('This email is invalid. Please use a valid email');
    } else {
      const email = guardianEmail;
      setGuardianEmail('');
      props.handleSubmit(email);
    }
  };

  return (
    <Dialog open={props.isOpen} onClose={closeModal}>
      <DialogTitle>Invite Guardian</DialogTitle>
      <DialogContent style={{ display: 'flex', minWidth: 600, flexDirection: 'column' }}>
        <TextField
          label="Add Guardian"
          name="addGuardian"
          value={guardianEmail}
          variant="outlined"
          size="small"
          margin="normal"
          onChange={(evt) => setGuardianEmail(evt.target.value)}
          helperText={
            guardianEmailError.length > 1
              ? guardianEmailError
              : 'Type in the email of the guardian you would like to add. Click submit to send the invitation'
          }
          error={guardianEmailError.length > 1}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={closeModal} color="error">
          Cancel
        </Button>
        <Button onClick={submit} disabled={props.isLoading}>
          Invite
        </Button>
      </DialogActions>
    </Dialog>
  );
}
